import {useGuestGroup} from './useGuestGroup';
import {useReservation} from 'context/reservation';
import {useSummary} from 'context/summary';
import {COUNTRY_CODES} from '@chekin/core';

export const useFirstGuestMustBeAdult = () => {
  const {hasNoGuests, isLoading: isLoadingGuestGroup} = useGuestGroup();
  const {housing, isLoading: isLoadingReservation} = useReservation();
  const {countryCode} = useSummary();

  return {
    isLoading: isLoadingReservation || isLoadingGuestGroup,
    firstGuestMustBeAdult:
      hasNoGuests &&
      countryCode === COUNTRY_CODES.uae &&
      housing?.is_police_registration_enabled,
  };
};
